module.exports = "//cdn-staging.livechat-static.com/webapp/img/automation/One-icon-animation.png?d66e2808cca774936fd9bc8032904ff8";